import React from "react";
import { TimeEditor } from "./TimeEditor";
import type { TimeEditorMenuProps } from "./types";

/**
 * Wrapper component for TimeEditor used in Cell context menu.
 * Provides the same props interface but can be extended for menu-specific behavior.
 */
export function TimeEditorMenu({ value, onSave, onCancel }: TimeEditorMenuProps) {
  return <TimeEditor value={value} onSave={onSave} onCancel={onCancel} />;
}
